import { TenantEntity } from '../TenantEntity'

export class EDIContainer extends TenantEntity {
  /**
   * @param {Object} data
   */
  constructor(data) {
    super(data)
  }
  // 非db 字段，关联装箱明细
  get containerUsage() {
    return this._data.containerUsage
  }
  set containerUsage(containerUsage) {
    this._data.containerUsage = containerUsage
  }
  // 非db字段，是否删除此装箱信息，用于后端逻辑判断
  get deleted() {
    return this._data.deleted
  }
  set deleted(deleted) {
    this._data.deleted = deleted || false
  }

  get containerNo() {
    return this._data.containerNo
  }
  set containerNo(containerNo) {
    this._data.containerNo = containerNo
  }
  get sealNo() {
    return this._data.sealNo
  }
  set sealNo(sealNo) {
    this._data.sealNo = sealNo
  }
  get eqType() {
    return this._data.eqType
  }
  set eqType(eqType) {
    this._data.eqType = eqType
  }
  get eqSize() {
    return this._data.eqSize
  }
  set eqSize(eqSize) {
    this._data.eqSize = eqSize
  }
  get quantity() {
    return this._data.quantity
  }
  set quantity(quantity) {
    this._data.quantity = quantity
  }
  get weight() {
    return this._data.weight
  }
  set weight(weight) {
    this._data.weight = weight
  }
  get cubage() {
    return this._data.cubage
  }
  set cubage(cubage) {
    this._data.cubage = cubage
  }
  get remarks() {
    return this._data.remarks
  }
  set remarks(remarks) {
    this._data.remarks = remarks
  }
  get hv() {
    return this._data.hv
  }
  set hv(hv) {
    this._data.hv = hv
  }
  get refNo() {
    return this._data.refNo
  }
  set refNo(refNo) {
    this._data.refNo = refNo
  }
  get payLoad() {
    return this._data.payLoad
  }
  set payLoad(payLoad) {
    this._data.payLoad = payLoad
  }
  get nr() {
    return this._data.nr
  }
  set nr(nr) {
    this._data.nr = nr
  }
  get temperature() {
    return this._data.temperature
  }
  set temperature(temperature) {
    this._data.temperature = temperature
  }
  get ventilated() {
    return this._data.ventilated
  }
  set ventilated(ventilated) {
    this._data.ventilated = ventilated
  }
  get openning() {
    return this._data.openning
  }
  set openning(openning) {
    this._data.openning = openning
  }
  get fumPol() {
    return this._data.fumPol
  }
  set fumPol(fumPol) {
    this._data.fumPol = fumPol
  }
  get fumDate() {
    return this._data.fumDate
  }
  set fumDate(fumDate) {
    this._data.fumDate = fumDate
  }
  get venPolDate() {
    return this._data.venPolDate
  }
  set venPolDate(venPolDate) {
    this._data.venPolDate = venPolDate
  }
  get fumUnNo() {
    return this._data.fumUnNo
  }
  set fumUnNo(fumUnNo) {
    this._data.fumUnNo = fumUnNo
  }
  get fumImoClass() {
    return this._data.fumImoClass
  }
  set fumImoClass(fumImoClass) {
    this._data.fumImoClass = fumImoClass
  }
  get deFumPod() {
    return this._data.deFumPod
  }
  set deFumPod(deFumPod) {
    this._data.deFumPod = deFumPod
  }
  get dcCerReceived() {
    return this._data.dcCerReceived
  }
  set dcCerReceived(dcCerReceived) {
    this._data.dcCerReceived = dcCerReceived
  }
  get oldContainer() {
    return this._data.oldContainer
  }
  set oldContainer(oldContainer) {
    this._data.oldContainer = oldContainer
  }
  get cargoDocUuid() {
    return this._data.cargoDocUuid
  }
  set cargoDocUuid(cargoDocUuid) {
    this._data.cargoDocUuid = cargoDocUuid
  }
  get mscCargoDocUuid() {
    return this._data.mscCargoDocUuid
  }
  set mscCargoDocUuid(mscCargoDocUuid) {
    this._data.mscCargoDocUuid = mscCargoDocUuid
  }
  get containerUsageUuid() {
    return this._data.containerUsageUuid
  }
  set containerUsageUuid(containerUsageUuid) {
    this._data.containerUsageUuid = containerUsageUuid
  }
  get cargoName() {
    return this._data.cargoName
  }
  set cargoName(cargoName) {
    this._data.cargoName = cargoName
  }
  get mark() {
    return this._data.mark
  }
  set mark(mark) {
    this._data.mark = mark
  }
  get hsCode() {
    return this._data.hsCode
  }
  set hsCode(hsCode) {
    this._data.hsCode = hsCode
  }
  get goodsCargoType() {
    return this._data.goodsCargoType
  }
  set goodsCargoType(goodsCargoType) {
    this._data.goodsCargoType = goodsCargoType
  }
  get undgNumber() {
    return this._data.undgNumber
  }
  set undgNumber(undgNumber) {
    this._data.undgNumber = undgNumber
  }
  get imoClass() {
    return this._data.imoClass
  }
  set imoClass(imoClass) {
    this._data.imoClass = imoClass
  }
  get containerStatus() {
    return this._data.containerStatus
  }
  set containerStatus(containerStatus) {
    this._data.containerStatus = containerStatus
  }
  get containerOwnershipCode() {
    return this._data.containerOwnershipCode
  }
  set containerOwnershipCode(containerOwnershipCode) {
    this._data.containerOwnershipCode = containerOwnershipCode
  }
  get packing() {
    return this._data.packing
  }
  set packing(packing) {
    this._data.packing = packing
  }
  get eqCode() {
    return this._data.eqCode
  }
  set eqCode(eqCode) {
    this._data.eqCode = eqCode
  }
  get eqHeight() {
    return this._data.eqHeight
  }
  set eqHeight(eqHeight) {
    this._data.eqHeight = eqHeight
  }
}
